<ng-container>
  <!-- Component -->
  <section
    class="popsy-text-field"
    [class.error]="error && initialized"
    *ngIf="loading !== true"
    (focus)="focus()">
    <label class="label" [for]="id || generatedId" *ngIf="label">
      <ng-container *ngIf="required">
        <strong class="required-indicator">*</strong>
        <span class="fixed-space-4" aria-hidden="true"></span>
      </ng-container>
      {{ label }}
    </label>
    <textarea
      data-clarity-unmask
      *ngIf="type === 'textarea'"
      #field
      class="field"
      name="field"
      [id]="id || generatedId"
      [attr.disabled]="disabled === true ? '' : null"
      [placeholder]="placeholder || ''"
      [formControl]="formControl"
      [attr.inputmode]="inputmode"
      [attr.autocomplete]="autocomplete"
      [minlength]="minlength || 0"
      [maxlength]="maxlength || ''"
      [tabindex]="focusIndex"
      (focus)="onFocused(true)"
      (blur)="onFocused(false)"></textarea>
    <input
      data-clarity-unmask
      *ngIf="type !== 'textarea'"
      #field
      type="text"
      class="field"
      name="field"
      [id]="id || generatedId"
      [attr.disabled]="disabled === true ? '' : null"
      [placeholder]="placeholder || ''"
      [formControl]="formControl"
      [attr.inputmode]="inputmode"
      [autocomplete]="autocomplete"
      [minlength]="minlength || 0"
      [maxlength]="maxlength || ''"
      [tabindex]="focusIndex"
      (focus)="onFocused(true)"
      (blur)="onFocused(false)" />
    <span class="error-label" *ngIf="error && initialized">{{ error }}</span>
  </section>

  <!-- Placeholder -->
  <div class="skeleton popsy-text-field" aria-hidden="true" *ngIf="loading === true">
    <popsy-skeleton class="skeleton label"></popsy-skeleton>
    <popsy-skeleton class="field-skeleton"></popsy-skeleton>
  </div>
</ng-container>
